<template>
    <div
        class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-col">
        <!-- Profile Picture and Basic Info -->
        <div class="p-6 flex-1">
            <div @click.stop="goToProfile" :title="`Click to view ${user.name}'s profile`"
                class="flex items-center space-x-4 mb-4 cursor-pointer group">
                <div class="relative">
                    <img :src="profilePicture(user.profile_picture_url)" :alt="user.name"
                        class="w-12 h-12 rounded-full object-cover border-2 border-gray-200" />
                    <div
                        :class="['absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white', getLoginStatusClass(user.login_status)]">
                    </div>
                </div>
                <div class="flex-1 min-w-0">
                    <h3
                        class="text-lg font-semibold text-gray-900 truncate group-hover:text-blue-600 transition-colors">
                        {{ user.name }}</h3>
                    <p class="text-sm text-gray-500 truncate group-hover:text-blue-600 transition-colors">{{ user.email
                    }}</p>
                </div>
            </div>

            <!-- User Details -->
            <div class="space-y-2 text-sm">
                <div class="flex justify-between">
                    <span class="text-gray-500 whitespace-nowrap">👤 Role:</span>
                    <span class="font-medium text-gray-900 text-right">{{ user.role_display_name ||
                        user.role_name
                        ||
                        '—' }}</span>
                </div>
                <div class="flex justify-between">
                    <span class="text-gray-500 whitespace-nowrap">📞 Phone:</span>
                    <span class="font-medium text-gray-900 text-right">{{ user.phone_number || '—'
                    }}</span>
                </div>
                <div class="flex justify-between">
                    <span class="text-gray-500 whitespace-nowrap">💼 Position:</span>
                    <span class="font-medium text-gray-900 text-right">{{ user.position || '—' }}</span>
                </div>
                <div class="flex justify-between">
                    <span class="text-gray-500 whitespace-nowrap">🏢 Entity:</span>
                    <span class="font-medium text-gray-900 text-right">{{ getEntityName(user.entity) ||
                        '—'
                    }}</span>
                </div>
                <div class="flex justify-between">
                    <span class="text-gray-500 whitespace-nowrap">🏫 Campus:</span>
                    <span class="font-medium text-gray-900 text-right">{{ user.campuses || '—' }}</span>
                </div>
                <div class="flex justify-between">
                    <span class="text-gray-500 whitespace-nowrap">🏛️ Department:</span>
                    <span class="font-medium text-gray-900 text-right">
                        {{ user.userDepartments && user.userDepartments.length > 0 ?
                            user.userDepartments[0].department
                            : '—' }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Action Buttons - Always at bottom -->
        <div class="p-6 pt-0">
            <div class="flex flex-wrap gap-2">
                <button @click="$emit('view-user', user)"
                    class="flex-1 min-w-0 bg-blue-600 text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors">
                    View
                </button>
                <button @click="$emit('edit-user', user)"
                    class="flex-1 min-w-0 bg-gray-600 text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700 transition-colors">
                    Edit
                </button>
            </div>
            <div class="w-full mt-2">
                <button v-if="isSuperAdmin" @click="$emit('impersonate-user', user)"
                    class="w-full bg-amber-600 text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-amber-700 transition-colors"
                    title="Switch to this user">
                    Impersonate
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserCard",
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    computed: {
        isSuperAdmin() {
            return this.$store.getters.isSuperAdmin;
        },
    },
    methods: {
        profilePicture(url) {
            if (!url) {
                return '/img/default-avatar.png';
            }
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        getEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        getLoginStatusClass(loginStatus) {
            switch (loginStatus) {
                case 'online':
                    return 'bg-green-500'; // Green for logged in
                case 'offline':
                    return 'bg-red-500'; // Red for logged out
                case 'unknown':
                default:
                    return 'bg-gray-500'; // Gray for unknown/neither
            }
        },
        goToProfile() {
            this.$router.push(`/profile/${this.user.token}`);
        },
    },
};
</script>
